let loaded = false;

function handleClick(e)
{
	if (e.target?.classList.contains('bvi-open') && !loaded)
	{
		e.preventDefault();
		loaded = true;

		BX.Runtime.loadExtension('redsign.university.bvi')
			.then(() => {
				init();
				document.removeEventListener('click', handleClick);

				setTimeout(() => {
					e.target.click();
				});
			});
	}
}

function getNode(node) {

	if (node.nodeType != Node.ELEMENT_NODE)
		return null;

	const el = node.closest('a, button, input, .btn, [title], [aria-label]');

	if (
		!el ||
		el.classList.contains('bvi-speech-play') ||
		el.classList.contains('bvi-speech-pause') ||
		el.classList.contains('bvi-speech-resume') ||
		el.classList.contains('bvi-speech-stop')
	) return null;

	return el;
}

function speechStartHandler({ target }) {

	const el = getNode(target);

	if (!el)
		return;

	var text = el.getAttribute('title') || el.getAttribute('aria-label') || el.value;

	if (!text) {
		text = el.textContent;
	}

	window.BVI._speech(text);
}

function speechStopHandler({ target }) {

	const el = getNode(target);

	if (!el)
		return;

	window.speechSynthesis.cancel();
}

function init()
{
	window.BVI = new Bvi();

	document.addEventListener(
		'mouseover',
		speechStartHandler,
		true
	);
	document.addEventListener(
		'mouseout',
		speechStopHandler,
		true
	);
	document.addEventListener(
		'focusin',
		speechStartHandler,
		true
	);
	document.addEventListener(
		'focusout',
		speechStopHandler,
		true
	);
}

document.addEventListener('DOMContentLoaded', () => {
	if ('Bvi' in window)
	{
		init();
	}
	else
	{
		document.addEventListener('click', handleClick)
	}
});